<template>
  <div
    class="module module-gallery"
    v-observe-visibility="visibilityChanged"
    :class="[
      { 'show-up': isVisible, 'small-gallery': !data.full_width },
      baseAnimation
    ]"
  >
    <ModuleHeading
      class="padding_large_tlr"
      v-if="data.image_header"
      :level="2"
      >{{ data.image_header }}</ModuleHeading
    >
    <ModuleContainer>
      <OwlCarousel :options="options" role="list">
        <li v-for="(image, i) in data.gallery_items" :key="i">
          <WpImage
            :data="image"
            size="extra_large"
            background
            caption
            class="wide-image"
            placeholder
            lazy
          />
        </li>
      </OwlCarousel>
    </ModuleContainer>
  </div>
</template>

<script>
import WpImage from "@/components/elements/WpImage";
import OwlCarousel from "@/components/elements/OwlCarousel";

export default {
  name: "gallery",
  props: ["data"],
  computed: {
    options() {
      const VM = this;
      return {
        items: 1,
        margin: 0,
        loop: false,
        center: false,
        nav: true,
        autoplay: false,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,
        freeDrag: false,
        callbacks: true,
        navText: [VM.svgIcons.arrow2, VM.svgIcons.arrow2]
      };
    }
  },

  components: {
    WpImage,
    OwlCarousel
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.module-gallery {
  .module-header {
    margin-bottom: 20px;
  }
  &.small-gallery {
    .owl-carousel {
      max-width: 671px;
      margin-left: auto;
      margin-right: auto;
    }
    figcaption {
      padding: 25px;
    }
    .owl-nav {
      bottom: 5px;
      right: 25px;
    }
  }
  padding: 0;
  .owl-nav {
    position: absolute;
    bottom: 50px;
    right: 50px;
    @include mquery(767px) {
      top: 5px;
      right: 5px;
      bottom: auto;
    }
    .owl-next,
    .owl-prev {
      margin: 10px;
      background: #eee !important;
      width: 32px;
      height: 32px;
      border-radius: 32px;
      position: relative;
      &.disabled {
        pointer-events: none;
        opacity: 0.5;
      }
      &:hover {
        background-color: #2a2e34 !important;
        svg g {
          fill: #fff;
        }
      }
      @include mquery(767px) {
        margin: 5px;
      }
      svg {
        position: absolute;
        height: 22px;
        width: 22px;
        top: 5px;
        left: 8px;
      }
    }

    .owl-prev {
      svg {
        transform: rotate(180deg);
        left: 3px;
        top: 5px;
      }
    }
  }
  .owl-dots {
    display: none;
  }
  .owl-item {
    list-style: none;
    li {
      list-style: none;
      @include mquery(767px) {
        overflow: visible;
      }
      .background-image {
        position: relative;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding-bottom: 0;
        .useholder {
          height: 100%;
          width: 100%;
          position: relative;
          padding-bottom: 56.25%;
        }
      }
    }
  }
}
</style>
